import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { AktifKullaniciBilgisiService } from './aktif-kullanici-bilgisi.service';
import { map, tap } from 'rxjs/operators';
import { RedirectPageDto } from '@core/models/RedirectPageDto';

@Injectable({
	providedIn: 'root'
})
export class RedirectPageService {

	constructor(
        private http: HttpClient,
        private aktifKullaniciBilgisiService: AktifKullaniciBilgisiService
    ) {
	}

    
	public LoginForRedirectPage(tokenBase64: string): Observable<any>  {
		return this.http.get<any>(environment.API_MOBIL + 'LoginForRedirectPage' + 
			'?base64AuthToken=' + tokenBase64 ).pipe(

			map((result: any) => {
				if (result instanceof Array) {
					return result.pop();
				}
				return result;
			}),

			tap(this.saveAccessData.bind(this))
		);
	  }

      private saveAccessData(accessData: any): boolean | void {
		if (typeof accessData !== 'undefined') {
			localStorage.setItem('a', accessData.a);
			this.aktifKullaniciBilgisiService.aktifKullaniciBilgisiniDoldur();
			return true;
		}
	}


}
